import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetVismonLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Parameters/GetLastDumpDate`
});

export const GetSiteListRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Parameters/GetSiteList`
});

export const GetParameterPlanningTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Parameters/GetPlanningHistory`
});

export const RunParameterPlanningRequest = (siteId, antenna, lteBands, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Parameters/RunParameterPlanning`,
	params: { siteId, antenna, lteBands, userId }
});

export const GetParameterPlanningExportRequest = (parameterPlanningId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Parameters/GetParameterPlanningExport`,
	params: { parameterPlanningId }
});
